import type { StyleRule } from '@archipro-design/aria';
import { pxToRem, pxArrayToRem } from '@archipro-design/aria';
import { boxClassName, videoPlayerClassName } from '@archipro-design/aria';
import type { ColumnDimensionType } from '@modules/page-builder/types';
import { PADDING_LEFT_RIGHT_SECTION_MOBILE } from '../../common/pagebuilder.style';

export const SingleVideoModule: StyleRule = () => ({
    margin: 0,
});

export const AspectRatioBox: StyleRule<{
    dimension?: ColumnDimensionType;
}> = ({ theme, dimension }) => ({
    position: 'relative',
    height: dimension?.mobileHeight ? pxToRem(dimension.mobileHeight) : '100%',
    width: dimension?.mobileWidth ? pxToRem(dimension.mobileWidth) : '100%',
    margin: '0 auto',

    [theme.screen.tablet]: {
        height: dimension?.tabletHeight
            ? pxToRem(dimension.tabletHeight)
            : '100%',
        width: dimension?.tabletWidth ? pxToRem(dimension.tabletWidth) : '100%',
    },

    [theme.screen.laptop]: {
        height: dimension?.height ? pxToRem(dimension.height) : '100%',
        width: dimension?.width ? pxToRem(dimension.width) : '100%',
        borderRadius: pxToRem(10),
        overflow: 'hidden',
    },

    [`& .${videoPlayerClassName}`]: {
        width: '100%',
        height: '100%',

        [`& .${boxClassName}`]: {
            position: 'absolute',
        },
    },
});

export const CaptionVideo: StyleRule<{
    dimension?: ColumnDimensionType;
}> = ({ theme, dimension }) => ({
    margin: `0 auto`,
    letterSpacing: '0.015em',
    width: dimension?.mobileWidth ? pxToRem(dimension.mobileWidth) : '100%',
    padding: pxArrayToRem([0, PADDING_LEFT_RIGHT_SECTION_MOBILE]),

    [theme.screen.tablet]: {
        width: dimension?.tabletWidth ? pxToRem(dimension.tabletWidth) : '100%',
    },

    [theme.screen.laptop]: {
        width: dimension?.width ? pxToRem(dimension.width) : '100%',
        padding: 0,
    },
});
